import { numberLocale } from 'src/config/locale';

export const formatNumber = (
  a: number,
  opts: {
    locale?: string;
    suffix?: string;
    prefix?: string;
  } & Intl.NumberFormatOptions = {},
): string =>
  `${opts.prefix ?? ''}${Intl.NumberFormat(opts.locale, {
    maximumFractionDigits: opts.maximumFractionDigits ?? 2,
    ...opts,
  }).format(a)}${opts.suffix ?? ''}`;

export const localFormatNumber: typeof formatNumber = (
  a: number,
  opts?: {
    locale?: string;
    suffix?: string;
    prefix?: string;
  } & Intl.NumberFormatOptions,
) => formatNumber(a, { locale: numberLocale, ...opts });
